import type {
  Row,
  TimeGridEntity,
  TimeGridEvent,
  TimeSlot,
} from 'modules/shift_management/components/ShiftManagement/TimeGridTable/types'

function areSetsEqual<T>(left: Set<T>, right: Set<T>): boolean {
  if (left.size !== right.size) return false

  for (const value of left) {
    if (!right.has(value)) return false
  }

  return true
}

function isRowSelectable<TEntity extends TimeGridEntity, TEvent extends TimeGridEvent>(
  row: Row<TEntity, TEvent> | undefined
): boolean {
  return row?.entity.selectable !== false
}

function countSelectableRows<TEntity extends TimeGridEntity, TEvent extends TimeGridEvent>(
  rows: Row<TEntity, TEvent>[]
): number {
  return rows.reduce((count, row) => {
    return isRowSelectable(row) ? count + 1 : count
  }, 0)
}

function isCellSelectable<TEntity extends TimeGridEntity, TEvent extends TimeGridEvent>(
  entityId: string,
  slotIndex: number,
  rows: Row<TEntity, TEvent>[],
  slots: TimeSlot[],
  rowIndexByEntityId: Map<string, number>,
  cellSelectable?: (entity: TEntity, slot: TimeSlot) => boolean
): boolean {
  const rowIndex = rowIndexByEntityId.get(entityId)
  if (rowIndex === undefined) return false

  const row = rows[rowIndex]
  if (!isRowSelectable(row)) return false

  const slot = slots[slotIndex]

  if (!row || !slot) return false
  if (!cellSelectable) return true

  return cellSelectable(row.entity, slot)
}

export { areSetsEqual, isRowSelectable, countSelectableRows, isCellSelectable }
